import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css'],
})
export class EmailComponent implements OnInit {
  @Input() from = '';
  @Input() password = '';
  @Output() createdPassword = new EventEmitter<FormGroup>();
  resetPasswordForm: FormGroup;
  textType: boolean;
  textType1: boolean;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.preparePasswordForm();
  }

  /**
   * Prepares password form
   */
  public preparePasswordForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: [
        this.password,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(128),
          Validators.pattern(/[^A-Z a-z 0-9]/),
          Validators.pattern(/[a-z]/),
          Validators.pattern(/[A-Z]/),
          Validators.pattern(/[0-9]/),
        ],
      ],
      currentPwd: [''],
    });
    if (this.from === 'account') {
      this.resetPasswordForm
        .get('currentPwd')
        .setValidators([Validators.required]);
    }
  }

  /**
   * Toggles text type for password
   */
  public toggleTextType(): void {
    this.textType = !this.textType;
  }

   /**
   * Toggles text type for password confirmation
   */
  public toggleTextType1(): void {
    this.textType1 = !this.textType1;
  }

  /**
   * Submits password form
   */
  public onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      this.createdPassword.emit(this.resetPasswordForm);
    }
  }

  /**
   * Checks password field
   * @param id number
   * @returns
   */
  public checkPassword(id: number) {
    let checkValidator = false;
    const re_symbol = /[^A-Za-z 0-9]/;
    const re_number = /[0-9]/;
    const re_lower = /[a-z]/;
    const re_upper = /[A-Z]/;
    switch (id) {
      case 0:
        // si le password contient au moins 8 cara et inférieur à 128
        if (
          this.resetPasswordForm.get('password').value.length >= 8 &&
          this.resetPasswordForm.get('password').value.length <= 128
        ) {
          checkValidator = true;
        }
        break;
      case 1:
        // si le password contient au moins 1 symbole
        if (this.resetPasswordForm.get('password').value.match(re_symbol)) {
          checkValidator = true;
        }
        break;
      case 2:
        // si le confirm password est identique au password
        if (
          this.resetPasswordForm.get('password').value ===
          this.resetPasswordForm.get('passwordConfirm').value
        ) {
          checkValidator = true;
        }
        break;
      case 3:
        // si le password contient au moins 1 majuscule
        if (this.resetPasswordForm.get('password').value.match(re_upper)) {
          checkValidator = true;
        }
        break;
      case 4:
        // si le password contient au moins 1 minuscule
        if (this.resetPasswordForm.get('password').value.match(re_lower)) {
          checkValidator = true;
        }
        break;
      case 5:
        // si le password contient au moins un nombre
        if (this.resetPasswordForm.get('password').value.match(re_number)) {
          checkValidator = true;
        }
        break;

      case 6:
        if (
          this.resetPasswordForm.get('password').value.match(re_symbol) &&
          this.resetPasswordForm.get('password').value.length >= 8 &&
          this.resetPasswordForm.get('password').value.length <= 128 &&
          this.resetPasswordForm.get('password').value.match(re_upper) &&
          this.resetPasswordForm.get('password').value.match(re_lower) &&
          this.resetPasswordForm.get('password').value.match(re_number)
        ) {
          checkValidator = true;
        }

        break;
      default:
        // nothing
        break;
    }
    return checkValidator;
  }
}
